<app-page-header [options]="options" (optionSelected)="optionSelected($event)"></app-page-header>
<div class="row" id="entireScreen">
  <div class="col-12">
    <app-storage-report-users-table
      *ngIf="this.storageReport.status.name != ''"
      (usersEvent)="receiveUsers($event)"
      [options]="options"
    ></app-storage-report-users-table>
  </div>
</div>
